import { render, staticRenderFns } from "./StrackDialog.vue?vue&type=template&id=37a66ae2&scoped=true"
import script from "./StrackDialog.vue?vue&type=script&lang=js"
export * from "./StrackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a66ae2",
  null
  
)

export default component.exports